module.exports = __webpack_public_path__ + "img/tree-01-j-trunk.721131bc.png";